import React, {Component} from "react";
import {Navbar as Bar} from 'react-bootstrap'
import '../static/scss/navbar.scss';
import {withRouter} from "react-router-dom";
import Security from "./security";

class Navbar extends Component {
    constructor() {
        super();

        this.state = {
            isAdmin: false,
            version: null
        };
    }

    componentDidMount() {
        this.getInitialState();
    }

    getInitialState = () => {
        Security.getUser((user) => {
            const isAdmin = user.ICHECAdmin;

            this.setState({ isAdmin });
        });

        const version = Security.version;
        this.setState({ version });
    }

    render() {
        const logo = require(`../static/svg/logo_${process.env.APP_DEPARTEMENT}.svg`).default;
        const { version, isAdmin } = this.state;

        return (
            <Bar expand="lg">
                <Bar.Brand href={process.env.APP_ROOT}>
                    <img src={logo} alt="logo"/>
                    <h3>Student</h3>
                </Bar.Brand>
                {isAdmin && <div
                    className={"d-block"}
                    style={{marginLeft: "auto", fontSize: "1.25rem"}}>
                    <span><i>Meteor</i> v<b>{version.apiVersion}</b> - <i>API</i> v<b>{version.meteorVersion}</b> - <i>FEND</i> v<b>{process.env.APP_VERSION}</b></span>
                </div>}
            </Bar>
        );
    }
}

export default withRouter(Navbar);